import { forwardRef, OnInit } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { debounceTime, skip, switchMap } from 'rxjs/operators';
import english from '../../../../../main/maintenances/i18n/en.json';
import spanish from '../../../../../main/maintenances/i18n/es.json';
import portuguese from '../../../../../main/maintenances/i18n/pt.json';
import { SegmentService } from '../../../../../main/settings/registers/segments/services/segment.service';
export function ValidateAutocomplete() {
    return { required: true };
}
var INPUT_FIELD_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return SegmentLegacyComponent; }),
    multi: true
};
var SegmentLegacyComponent = /** @class */ (function () {
    function SegmentLegacyComponent(fuseTranslationLoaderService, segmentService) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.segmentService = segmentService;
        this.segments = new Array();
        this.inputValue = new FormControl();
        this.loading = false;
        this.onChange = function () { };
        this.onTouched = function () { };
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    SegmentLegacyComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.inputValue.valueChanges
            .pipe(skip(1), debounceTime(500), switchMap(function (searchTerm) {
            _this.loading = true;
            _this.segments = [];
            return _this.segmentService.loadData({
                where: {
                    name_contains: searchTerm
                },
                options: {
                    orderBy: 'name_asc',
                    offset: 0,
                    limit: 10
                }
            });
        }))
            .subscribe(function (result) {
            _this.loading = false;
            _this.segments = result.items;
        });
    };
    SegmentLegacyComponent.prototype.writeValue = function (segmentId) {
        var _this = this;
        if (segmentId) {
            this.segmentService.getSegmentById(segmentId).then(function (segment) {
                _this.selectedSegment = segment;
                _this.inputValue.setErrors(null);
            });
        }
        else {
            this.deselectSegment();
        }
    };
    SegmentLegacyComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    SegmentLegacyComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    SegmentLegacyComponent.prototype.setSelectedSegment = function () {
        var _this = this;
        if (this.inputValue.value) {
            this.onChange(this.inputValue.value);
            this.selectedSegment = this.segments.find(function (location) { return location.id === _this.inputValue.value; });
            this.inputValue.setErrors(null);
        }
    };
    SegmentLegacyComponent.prototype.deselectSegment = function () {
        this.onChange(null);
        this.inputValue.setValue(null);
        this.selectedSegment = null;
        this.inputValue.setErrors(null);
    };
    return SegmentLegacyComponent;
}());
export { SegmentLegacyComponent };
